module.exports = __webpack_public_path__ + "static/media/BTI-logo.230422e9.webp";